"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@logbook/shared");
var material_1 = require("@angular/material");
var shared_2 = require("@logbook/shared");
var mixpanel_service_1 = require("../../../../../../../app/core/tracking/mixpanel.service");
var mixpanel_event_enum_1 = require("../../../../../../../app/core/tracking/mixpanel-event.enum");
var operators_1 = require("rxjs/operators");
var InviteColeagueModalComponent = /** @class */ (function () {
    function InviteColeagueModalComponent(data, dialogRef, invitationService, mixpanelService, notificationsService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.invitationService = invitationService;
        this.mixpanelService = mixpanelService;
        this.notificationsService = notificationsService;
        this.isLoading = false;
        this.skipApiCall = true;
        (this.data) ? this.skipApiCall = this.data.skipApiCall : this.skipApiCall = false;
    }
    InviteColeagueModalComponent.prototype.cancel = function () {
        this.dialogRef.close(null);
    };
    InviteColeagueModalComponent.prototype.sendInvitation = function () {
        var _this = this;
        if (this.invitationForm.valid && this.colleagueEmail.indexOf('@') > -1) {
            if (!this.skipApiCall) {
                this.invitationService.sendInvitation(this.colleagueEmail).pipe(operators_1.first()).subscribe(function (message) {
                    _this.mixpanelService.track(mixpanel_event_enum_1.MixpanelEvent.SEND_INVITATION, { "member mail": _this.colleagueEmail });
                    _this.notificationsService.success("Invitation sent", message.message);
                    _this.dialogRef.close(_this.colleagueEmail);
                }, function (error) {
                    _this.notificationsService.error("Invitation cannot be send", _this.colleagueEmail + ' is already member of a team');
                    _this.dialogRef.close(null);
                });
            }
            else {
                this.dialogRef.close(this.colleagueEmail);
            }
        }
        else {
            this.notificationsService.error("Invitation cannot be send", "Please verify inserted email");
        }
    };
    return InviteColeagueModalComponent;
}());
exports.InviteColeagueModalComponent = InviteColeagueModalComponent;
